"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _unstatedNext = require("./unstated-next");

var _useLatest = _interopRequireDefault(require("./useLatest"));

var _useMap3 = _interopRequireDefault(require("./useMap"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var useContext = function useContext(options) {
  var oneConfigRef = (0, _useLatest["default"])(options === null || options === void 0 ? void 0 : options.oneConfig);
  var optionsRef = (0, _useLatest["default"])(options);

  var _useMap = (0, _useMap3["default"])(),
      _useMap2 = (0, _slicedToArray2["default"])(_useMap, 2),
      map = _useMap2[0],
      utils = _useMap2[1];

  return _objectSpread(_objectSpread({
    oneConfig: oneConfigRef.current,
    options: optionsRef.current
  }, utils), {}, {
    map: map
  });
};

var _default = (0, _unstatedNext.createContainer)(useContext);

exports["default"] = _default;